export default function assignAnnotations(trend, annotations, granularity) {
    if (annotations.length < 1 || !trend) return [];
    const annotatedChicklets = [];
    const startTime = trend[0].date;
    const endTime = trend[trend.length - 1].date + granularity;

    // annotations collection is an array of tuples.  Each annotation tuple has the following data:
    // [0]: (String) the UUID of the annotation
    // [1]: (Num) the timestamp where the annotation should appear on its assigned status chart(s)
    // [2]: (String) the string of the annotation's note itself
    // annotations collection stores annotations in reverse chronological order
    if (annotations[0][1] < startTime || annotations[annotations.length - 1][1] > endTime) return;

    // make a list in chronological order of all annotations within the bounds of the current status chart
    const trimmedList = [];
    annotations.forEach((annotation) => {
        if (annotation[1] < startTime || annotation[1] > endTime) return;
        trimmedList.unshift(annotation);
    });

    // simultaneously iterate the trend collection and in-bounds annotations collection to collate them
    let i = 0;
    let isFinished = false;
    trend.forEach((point) => {
        if (point.value === null || point.value === undefined) return;
        if (!isFinished && trimmedList[i]) {
            while (trimmedList[i][1] < point.date && !isFinished) {
                if (i < trimmedList.length - 1) i += 1;
                else {
                    isFinished = true;
                    return;
                }
            }

            if (trimmedList[i][1] >= point.date && trimmedList[i][1] < point.date + granularity) {
                if (!point.isAnnotated) {
                    point.isAnnotated = true;
                    point.annotations = [];
                }
                point.annotations.push(trimmedList[i][2]);
                annotatedChicklets.push(point);
            }
        }
    });

    return annotatedChicklets;
}
